import React from "react";
import { Text } from "@bookingcom/bui-react";
export const Disclaimers = ({ disclaimers }) => {
    if (disclaimers.length === 0) {
        return null;
    }
    return (React.createElement("div", null, disclaimers.map((disclaimer, index) => (React.createElement(Text, { variant: "small_2", color: "neutral_alt", key: `kDisclaimer_${index}` }, disclaimer)))));
};
